import styled from 'styled-components'

import { Main } from './Main'
import { Sub } from './Sub'
import { Modal } from './Modal'

export interface HeaderProps {
  type: 'MAIN' | 'SUB' | 'MODAL'
  title?: string
  isBack?: boolean
  isRoute?: boolean
  fixed?: boolean
  background?: 'black' | 'white' | 'transparent' | 'gradient'
  rightItem?: any
  href?: string
  isScrollEvent?: boolean
  isScrolling?: boolean
  onBack?: () => void
  onDismiss?: () => void
}

export type HeaderContentProps = Omit<HeaderProps, 'type'>

export function Header(props: HeaderProps) {
  const { type, fixed, background = 'white', isScrollEvent, isScrolling, rightItem } = props
  return (
    <StyledHeader
      type={type}
      fixed={fixed}
      background={background}
      isScrollEvent={isScrollEvent}
      isScrolling={isScrolling}
      rightItem={rightItem}
    >
      {type === 'MAIN' && <Main />}
      {type === 'SUB' && <Sub {...props} />}
      {type === 'MODAL' && <Modal {...props} />}
    </StyledHeader>
  )
}

const StyledHeader = styled.div<
  Pick<HeaderProps, 'type' | 'fixed' | 'background' | 'isScrollEvent' | 'isScrolling' | 'rightItem'>
>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: ${({ fixed }) => (fixed ? 'absolute' : 'relative')};
  z-index: 10;
  width: 100%;
  padding: ${({ type, isScrollEvent, rightItem }) => (type === 'MAIN' || isScrollEvent || rightItem ? '16px 16px 8px' : '8px 16px')};
  background: ${({ background }) => {
    switch (background) {
      case 'black':
        return '#000000'
      case 'white':
        return '#FFFFFF'
      case 'transparent':
        return 'transparent'
      case 'gradient':
        return 'linear-gradient(180deg, rgba(0, 0, 0, 0.71) 0.64%, rgba(0, 0, 0, 0) 99.36%)'
      default:
        return '#FFFFFF'
    }
  }}};
  ${({ isScrollEvent, isScrolling }) =>
    isScrollEvent &&
    `${
      isScrolling
        ? ''
        : `
          background: transparent;
          &::after {
            display: block;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            width: 100%;
            height: 100px;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.71) 0.64%, rgba(0, 0, 0, 0) 99.36%);
          }
        `
    }
  `}
`

export const LeftButtonBox = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 8px;
  cursor: pointer;
`
